import { c as _c } from "react-compiler-runtime";
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { PublicRecapTab } from './PublicRecapTab';
import { jsx as _jsx } from "react/jsx-runtime";
export const PublicRecapCard = t0 => {
  const $ = _c(2);
  const {
    recapHtml
  } = t0;
  let t1;
  if ($[0] !== recapHtml) {
    t1 = /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsx(CardSection, {
        children: /*#__PURE__*/_jsx(PublicRecapTab, {
          summaryHtml: recapHtml
        })
      })
    });
    $[0] = recapHtml;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};